import { FC, Suspense } from 'react';
import { Link, Outlet, useLocation, useParams, useSearchParams } from 'react-router-dom';
import ConversationPageHeader, { ConversationPageHeaderSkeleton } from '../../components/conversation-page-header';
import { ContactDetailsSidebar } from '../../components/contact-details-sidebar/contact-details-sidebar';
import { cn } from '@shadcn/ui/lib/utils';
import { useSidebars } from '@shadcn/ui/hooks/use-sidebars';
import { ActionCardList } from './components/action-card-list/action-card-list';
import { Input } from '@shadcn/ui/components/ui/input';
import { MessageCircle, SparklesIcon } from 'lucide-react';
import { Button } from '@shadcn/ui/components/ui/button';
import { motion } from 'motion/react';
import { ActionChatRuntimeProvider } from './components/action-chat/action-chat-runtime-provider';
import { ActionAgentPromptInput } from './components/action-agent-prompt-input';

export const ActionsPageV2: FC = () => {
    const { contactId, actionCardType } = useParams();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const threadId = searchParams.get('threadId') || undefined;

    // Check if we're on a chat route or other routes that don't need contactId
    const isOnChatRoute = location.pathname.includes('/actions-v2/chat');
    const shouldShowOutlet = contactId || isOnChatRoute;

    return (
        <ActionChatRuntimeProvider>
            <div className="flex h-full max-w-full overflow-hidden">
                <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                    <div className="flex flex-col">
                        <div className="flex flex-col gap-2 border-b p-4">
                            <h1 className="text-2xl font-bold">Actions</h1>
                            <motion.div
                                className="flex flex-row gap-2 w-[min(70dvw,60rem)] max-w-full self-center overflow-hidden"
                                animate={{
                                    height: isOnChatRoute ? 0 : 'auto',
                                    opacity: isOnChatRoute ? 0 : 1,
                                }}
                                transition={{
                                    duration: 0.1,
                                    ease: 'easeInOut',
                                }}
                            >
                                <ActionAgentPromptInput />
                                <Link
                                    to={{
                                        pathname: '/new/actions-v2/chat',
                                        search: threadId ? '?threadId=' + threadId : '',
                                    }}
                                >
                                    <Button>
                                        <SparklesIcon className="w-4 h-4" />
                                        <span>Chat</span>
                                    </Button>
                                </Link>
                            </motion.div>
                        </div>
                        <ActionCardList />
                    </div>
                </div>

                <div
                    className={cn(
                        'flex flex-col border-l max-w-2/3 overflow-hidden h-full max-h-full justify-end w-0 transition-[width] duration-300 ease-in-out',
                        {
                            'w-2/3': shouldShowOutlet,
                        }
                    )}
                >
                    <Outlet />
                </div>
            </div>
        </ActionChatRuntimeProvider>
    );
};

export default ActionsPageV2;
